(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

},{}],2:[function(require,module,exports){
"use strict";

require("./app/polyfills");

require("./app/popup");

require("./app/form");

require("./app/inputs");

require("./app/scroll");

require("./app/tooltip");

require("./app/glossary");

require("./app/dropdown-menu");

require("./app/load-more");

require("./app/rating");

require("./app/mobile-menu");

require("./app/glide");

require("./app/common");

require("./app/accordion");

},{"./app/accordion":3,"./app/common":4,"./app/dropdown-menu":5,"./app/form":6,"./app/glide":7,"./app/glossary":8,"./app/inputs":9,"./app/load-more":10,"./app/mobile-menu":11,"./app/polyfills":12,"./app/popup":13,"./app/rating":14,"./app/scroll":15,"./app/tooltip":16}],3:[function(require,module,exports){
"use strict";

(function (window, document, $) {
  var $accordion = $(".accordion");

  if ($accordion) {
    $(".accordion__expand").on("click", function (e) {
      var $btn = $(this);
      var $title = $btn.find("i");
      var $parent = $btn.parent();
      $btn.toggleClass("expanded");

      if ($btn.hasClass("expanded")) {
        $parent.find(".collapse").collapse("show");
        $title.text($btn.data("collapse"));
      } else {
        $parent.find(".collapse").collapse("hide");
        $title.text($btn.data("expand"));
      }
    });
    $accordion.on("hide.bs.collapse", function () {
      if ($(this).find(".show").length === 1) {
        var $btn = $(this).find(".accordion__expand");
        $btn.removeClass("expanded").find("i").text($btn.data("expand"));
      }
    });
    $accordion.on("show.bs.collapse", function () {
      if ($(this).find(".collapse:not(.show)").length === 1) {
        var $btn = $(this).find(".accordion__expand");
        $btn.addClass("expanded").find("i").text($btn.data("collapse"));
      }
    });
  }
})(window, document, jQuery);

},{}],4:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

window.onload = function () {
  if ((typeof VK === "undefined" ? "undefined" : _typeof(VK)) === 'object') {
    VK.Goal('page_view');
  }
};

},{}],5:[function(require,module,exports){
"use strict";

var menuItems = document.querySelectorAll('[data-toggle="dropdown-menu"]');
var menuCloses = document.querySelectorAll('.dropdown-menu__close');
;

var closeMenuByOuterClick = function closeMenuByOuterClick(e) {
  closeMenu(e.target);
};

var closeMenu = function closeMenu() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  menuItems.forEach(function (item) {
    if (target) {
      if (!item.contains(target)) {
        item.classList.remove('show');
      }
    } else {
      item.classList.remove('show');
    }
  });
};

var closeMenuManually = function closeMenuManually() {
  menuItems.forEach(function (item) {
    item.classList.remove('show');
  });
};

menuItems.forEach(function (item) {
  item.addEventListener('mouseover', function () {
    var _this = this;

    menuItems.forEach(function (item) {
      if (item !== _this) {
        item.classList.remove('show');
      }
    });
    this.classList.add('show');
  });
});
menuCloses.forEach(function (menuClose) {
  menuClose.addEventListener('click', closeMenuManually);
});
document.addEventListener('click', closeMenuByOuterClick);

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formsToDef = void 0;

var _popup = require("./popup");

var _ctaGoals = require("../modules/cta-goals");

var forms = document.querySelectorAll('form'); //TODO: refactor, change e to form

var formsToDef = function formsToDef(e) {
  e.querySelectorAll('input, textarea').forEach(function (input) {
    if (input.type !== 'hidden') {
      var inputControl = input.parentElement;
      var errorMsg = inputControl.querySelector('.error-msg');
      document.querySelector('input[type="checkbox"]:checked').checked = false;
      input.value = '';
      inputControl.classList.remove('error', 'filled');

      if (errorMsg) {
        errorMsg.remove();
      }
    }
  });
  var formBody = e.querySelector('.form__body');

  if (formBody && formBody.classList.contains('hidden')) {
    formBody.classList.remove('hidden');
    e.querySelector('.response-msg').remove();
  }
};

exports.formsToDef = formsToDef;

var onResponseFalse = function onResponseFalse(form, xhr, response) {
  var inputs = form.querySelectorAll('.input-control');
  inputs.forEach(function (input) {
    var errorMsg = input.parentElement.querySelector('.error-msg');
    var inputWrap = input.parentElement;

    for (var error in response.errors) {
      if (input.name === response.errors[error].field && !errorMsg) {
        inputWrap.classList.add('error');
        input.insertAdjacentHTML('afterend', '<span class="error-msg">' + response.errors[error].message + '</span>');
      }
    }
  });
};

if (forms.length) {
  forms.forEach(function (item) {
    item.addEventListener('submit', function (e) {
      e.preventDefault();
      var form = e.target;
      var url = form.getAttribute('action');
      var data = new FormData(form);
      var fileInput = form.querySelector('input[type="file"]');

      if (fileInput) {
        for (var i = 0; i < fileInput.files.length; i++) {
          var file = fileInput.files[i];
          data.append('files[]', file);
        }
      }

      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.send(data);

      xhr.onreadystatechange = function () {
        if (xhr.readyState === xhr.DONE && xhr.status === 200) {
          var response = JSON.parse(xhr.responseText);

          if (response.status === 'error') {
            onResponseFalse(form, xhr, response);
          } else {
            var isModal = form.closest('.popup');
            var formBody = form.querySelector('.form__body');
            var formFooter = form.querySelector('.form__footer');
            var footerBtn = form.querySelector('.form__footer-btn');

            if (isModal) {
              formBody.insertAdjacentHTML('afterend', '<div class="response-msg">' + response["message"] + '</div>');
              formBody.classList.add('hidden');
              formBody.style.display = 'none';
              formFooter.classList.add('show');
              footerBtn.addEventListener('click', function () {
                formFooter.classList.remove('show');
                formBody.style.display = 'flex';
                formBody.classList.remove('hidden');
                var response = form.querySelector('.response-msg');

                if (response) {
                  form.removeChild(response);
                }
              });
            } else {
              document.querySelector('#popup--success .popup__content').innerHTML = response['message'];
              formsToDef(form);
              (0, _popup.openPopup)(null, 'popup--success');
            }

            (0, _ctaGoals.reachGoals)(response.counters.goals.ym, response.counters.goals.ga, response.counters.goals.ga4, response.counters.goals.fb, 'submit_application', 'lead');
          }
        }
      };
    });
  });
}

},{"../modules/cta-goals":18,"./popup":13}],7:[function(require,module,exports){
"use strict";

var _glide = _interopRequireDefault(require("../vendor/glide.min"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var sliders = document.querySelectorAll('.glide') || [];
sliders.forEach(function (slider) {
  var currentSlideNumber = slider.querySelector('[data-toggle="slider-current-item"]');
  var glide = new _glide["default"](slider, {
    type: 'carousel',
    startAt: 0,
    perView: 1,
    gap: 30
  });
  glide.on('run.after', function () {
    currentSlideNumber.textContent = glide.index + 1;
  });
  glide.mount();
});

},{"../vendor/glide.min":21}],8:[function(require,module,exports){
"use strict";

var _ajaxHandler = _interopRequireDefault(require("../modules/ajax-handler"));

var _tooltip = _interopRequireDefault(require("../modules/tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var links = document.querySelectorAll('.glossary-link:not(.disabled)');
var allItems = document.querySelectorAll('.glossary-item');
var glossaryTags = document.querySelectorAll('.glossary-filter__tag');

var glossaryListener = function glossaryListener(e, links, allItems) {
  e.preventDefault();
  var category = e.target.getAttribute('data-letter');
  links.forEach(function (linkInner) {
    linkInner.classList.remove('active');

    if (linkInner.getAttribute('data-letter') === category) {
      linkInner.classList.add('active');
    }
  });

  if (category !== 'all') {
    allItems.forEach(function (item) {
      item.classList.add('inactive');
    });
    setTimeout(function () {
      document.querySelectorAll('.glossary-item[data-letter="' + category + '"]').forEach(function (catItem) {
        catItem.classList.remove('inactive');
      });
    }, 200);
  } else {
    allItems.forEach(function (catItem) {
      catItem.classList.remove('inactive');
    });
  }
};

if (links.length) {
  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      glossaryListener(e, links, allItems);
    });
  });
}

var glossaryFiltering = function glossaryFiltering(e) {
  e.preventDefault();
  e.target.classList.toggle('active');
  var data = new FormData();
  var tags = '';
  glossaryTags.forEach(function (tag) {
    if (tag.classList.contains('active')) {
      tags += tag.getAttribute('data-tag') + ',';
    }
  });
  data.append('tags', tags);
  data.append('action', 'glossary_filter');
  var ajaxHandler = new _ajaxHandler["default"]({
    'url': '/wp-admin/admin-ajax.php'
  });
  ajaxHandler.send(data, function () {
    var response = ajaxHandler.response;
    document.querySelector('.glossary-letters').innerHTML = response.head;
    document.querySelector('.glossary-body').innerHTML = response.body;
    var links = document.querySelectorAll('.glossary-link:not(.disabled)');
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        glossaryListener(e, links, document.querySelectorAll('.glossary-item'));
      });
    });
    document.querySelectorAll('.glossary-filter__tag').forEach(function (tag) {
      tag.addEventListener('click', glossaryFiltering);
    });
  });
};

if (glossaryTags.length) {
  glossaryTags.forEach(function (tag) {
    tag.addEventListener('click', glossaryFiltering);
  });
}

var glossaryPopupLink = document.querySelectorAll('.glossary-popup-link');

if (glossaryPopupLink.length) {
  glossaryPopupLink.forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      link.classList.add('active');
      var tooltip = link.querySelector('.tooltip');

      if (!tooltip) {
        var data = new FormData();
        data.append('action', 'glossary_terms');
        data.append('id', link.getAttribute('data-id'));
        var ajaxHandler = new _ajaxHandler["default"]({
          'url': '/wp-admin/admin-ajax.php'
        });
        ajaxHandler.send(data, function () {
          var response = ajaxHandler.response;
          link.insertAdjacentHTML('beforeend', '<a href="' + response['uri'] + '" class="glossary-popup tooltip visible active">' + '<div class="glossary-popup__body">' + '<span>' + response['title'] + '</span> - ' + response['content'] + '' + '</div>' + '</a>');
          new _tooltip["default"](link.querySelector('.tooltip')).init();
        });
      }
    });
    link.addEventListener('mouseleave', function () {
      return link.classList.remove('active');
    });
  });
}

},{"../modules/ajax-handler":17,"../modules/tooltip":20}],9:[function(require,module,exports){
"use strict";

var inputs = document.querySelectorAll('.input-wrap input, .input-wrap textarea');

var inputFocus = function inputFocus(e) {
  var input = e.target;
  var inputControl = input.parentElement;
  inputControl.classList.add('focused');
};

var inputBlur = function inputBlur(e) {
  var input = e.target;
  var inputControl = input.parentElement;
  inputControl.classList.remove('focused');

  if (input.value !== '') {
    inputControl.classList.add('filled');
    inputControl.classList.remove('error');
  } else {
    inputControl.classList.remove('filled');
  }
};

var inputTyping = function inputTyping(e) {
  var input = e.target;
  var inputControl = input.parentElement;
  var errorMsg = inputControl.querySelector('.error-msg');
  inputControl.classList.remove('error');

  if (errorMsg) {
    errorMsg.remove();
  }
};

if (inputs.length) {
  inputs.forEach(function (item) {
    item.addEventListener('focus', inputFocus);
  });
  inputs.forEach(function (item) {
    item.addEventListener('blur', inputBlur);
  });
  inputs.forEach(function (item) {
    item.addEventListener('input', inputTyping);
  });
}

var fileInputs = document.querySelectorAll('input[type="file"]');

if (fileInputs.length) {
  fileInputs.forEach(function (input) {
    var fileWrap = input.parentElement;

    if (!fileWrap.classList.contains('input-file-wrap')) {
      fileWrap = fileWrap.parentElement;
    }

    input.addEventListener('change', function (e) {
      var that = e.target;
      var files = that.files;
      var filesStr = '';
      Array.from(files).forEach(function (file, index) {
        if (index) {
          filesStr += ', ';
        }

        filesStr += file.name;
      });
      fileWrap.querySelector('[data-toggle="filename"]').textContent = filesStr;
      var fileHolder = fileWrap.querySelector('.input-file-wrap__holder');

      if (input.value) {
        fileHolder.classList.add('visible');
        fileWrap.classList.add('selected');
      } else {
        fileHolder.classList.remove('visible');
        fileWrap.classList.remove('selected');
      }
    });
    fileWrap.querySelector('.input-file-wrap__rm-btn').addEventListener('click', function (e) {
      input.value = '';
      var that = e.target;
      that.parentElement.classList.remove('visible');
      fileWrap.classList.remove('selected');
    });
  });
}

var checkboxes = document.querySelectorAll('.checkbox .checkbox__input');

if (checkboxes.length) {
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', function (e) {
      e.target.parentElement.classList.toggle('checked');
    });
  });
}

},{}],10:[function(require,module,exports){
"use strict";

var _loadMore = _interopRequireDefault(require("../modules/load-more"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var loadMoreBtns = document.querySelectorAll('.loadmore-btn');
loadMoreBtns.forEach(function (btn) {
  return new _loadMore["default"](btn);
});

},{"../modules/load-more":19}],11:[function(require,module,exports){
"use strict";

var allMenuItems = document.querySelectorAll('.mobile-menu__item');
var menuItems = document.querySelectorAll('[data-toggle="submenu"]');
menuItems.forEach(function (item) {
  item.children[0].addEventListener('click', function () {
    item.classList.toggle('show');
    allMenuItems.forEach(function (menuItem) {
      if (menuItem !== item) {
        menuItem.classList.toggle('hidden');
      }
    });
  });
});

},{}],12:[function(require,module,exports){
"use strict";

if (!Element.prototype.closest) {
  Element.prototype.closest = function (css) {
    var node = this;

    while (node) {
      if (node.matches(css)) return node;else node = node.parentElement;
    }

    return null;
  };
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;
}

if ('NodeList' in window && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;

    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  // helpers
  var regExp = function regExp(name) {
    return new RegExp('(^| )' + name + '( |$)');
  };

  var forEach = function forEach(list, fn, scope) {
    for (var i = 0; i < list.length; i++) {
      fn.call(scope, list[i]);
    }
  }; // class list object with basic methods


  function ClassList(element) {
    this.element = element;
  }

  ClassList.prototype = {
    add: function add() {
      forEach(arguments, function (name) {
        if (!this.contains(name)) {
          this.element.className += ' ' + name;
        }
      }, this);
    },
    remove: function remove() {
      forEach(arguments, function (name) {
        this.element.className = this.element.className.replace(regExp(name), '');
      }, this);
    },
    toggle: function toggle(name) {
      return this.contains(name) ? (this.remove(name), false) : (this.add(name), true);
    },
    contains: function contains(name) {
      return regExp(name).test(this.element.className);
    },
    // bonus..
    replace: function replace(oldName, newName) {
      this.remove(oldName), this.add(newName);
    }
  }; // IE8/9, Safari

  if (!('classList' in Element.prototype)) {
    Object.defineProperty(Element.prototype, 'classList', {
      get: function get() {
        return new ClassList(this);
      }
    });
  } // replace() support for others


  if (window.DOMTokenList && DOMTokenList.prototype.replace == null) {
    DOMTokenList.prototype.replace = ClassList.prototype.replace;
  }
})();

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closePopup = exports.openPopup = void 0;

var _form = require("./form");

var _ctaGoals = require("../modules/cta-goals");

var btns = document.querySelectorAll('[data-toggle="modal"]');
var body = document.querySelector('body');
var closeBtns = document.querySelectorAll('.popup-close-btn');

var isMobileDevice = function isMobileDevice() {
  return typeof window.orientation !== "undefined" || navigator.userAgent.indexOf('IEMobile') !== -1;
};

var closePopupByOuterClick = function closePopupByOuterClick(e) {
  var popup = document.querySelector('.popup.visible');

  if (popup && !popup.contains(e.target) && (!e.target.getAttribute('data-toggle') || e.target.getAttribute('data-toggle') !== 'modal')) {
    closePopup();
  }
};

var openPopupWorker = function openPopupWorker(e, sel) {
  var btn, dataTitle, dataFormId;

  if (e) {
    btn = e.target;
    dataTitle = btn.getAttribute('data-title');
    dataFormId = btn.getAttribute('data-form-id');
  }

  var item = document.getElementById(sel);
  var popupContainer = item.parentElement.parentElement;

  if (dataTitle) {
    item.querySelector('input[name="form_title"]').value = dataTitle;
    item.querySelector('.popup__title').textContent = dataTitle;
  }

  if (dataFormId) {
    item.querySelector('input[name="form_id"]').value = dataFormId;
  }

  var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  if (popupContainer.querySelector('.mobile-menu__body')) {
    var MOBILE_PADDINGS_OFFSET = 340;
    popupContainer.querySelector('.mobile-menu__body').style.maxHeight = window.innerHeight - MOBILE_PADDINGS_OFFSET + 'px';
  }

  body.classList.add('popup-open');
  popupContainer.style.display = 'block';
  popupContainer.classList.add('visible');

  if (!isMobileDevice()) {
    body.style.paddingRight = scrollbarWidth + 'px';
  }

  setTimeout(function () {
    item.classList.add('visible');
    document.addEventListener('click', closePopupByOuterClick);
  }, 10);
};

var openPopup = function openPopup(e, sel) {
  var openedPopup = document.querySelector('.popup.visible');

  if (openedPopup) {
    closePopup();
    setTimeout(function () {
      return openPopupWorker(e, sel);
    }, 400);
  } else {
    openPopupWorker(e, sel);
  }

  (0, _ctaGoals.reachGoals)('open', '', '', 'initiate_checkout', 'click');
};

exports.openPopup = openPopup;

var closePopup = function closePopup() {
  var popup = document.querySelector('.popup.visible');
  var popupContainer = popup.parentElement.parentElement;
  popup.classList.remove('visible');

  if (popup.id === 'mobile-menu') {
    var allMenuItems = document.querySelectorAll('.mobile-menu__item');
    allMenuItems.forEach(function (item) {
      item.classList.remove('hidden');
      item.classList.remove('show');
    });
  }

  if (popup.id === 'popup--def') {
    var form = popup.querySelector('.form');
    var formBody = form.querySelector('.form__body');
    var formFooter = form.querySelector('.form__footer');
    formFooter.classList.remove('show');
    formBody.style.display = 'flex';
    formBody.classList.remove('hidden');
    var response = form.querySelector('.response-msg');

    if (response) {
      form.removeChild(response);
    }
  }

  setTimeout(function () {
    popupContainer.style.display = 'none';
    popupContainer.classList.remove('visible');
    body.style.paddingRight = '0';
    body.classList.remove('popup-open', 'popup-open-bar'); //TODO: refactor, pass form instead of popup

    (0, _form.formsToDef)(popup);
  }, 300);
  document.removeEventListener('click', closePopupByOuterClick);
};

exports.closePopup = closePopup;

var btnsListener = function btnsListener(btns) {
  btns.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      openPopup(e, item.getAttribute('data-target'));
    });
  });
};

if (btns.length) {
  btnsListener(btns);
}

if (closeBtns.length) {
  closeBtns.forEach(function (item) {
    item.addEventListener('click', closePopup);
  });
}

document.addEventListener('keydown', function (event) {
  var key = event.key;
  var popup = document.querySelector('.popup.visible');

  if (popup && key === "Escape") {
    closePopup();
  }
});

},{"../modules/cta-goals":18,"./form":6}],14:[function(require,module,exports){
"use strict";

var _ajaxHandler = _interopRequireDefault(require("../modules/ajax-handler"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var starsContainer = document.querySelector('.rating-active:not(.disabled)');

if (starsContainer) {
  var postId = starsContainer.getAttribute('data-id');
  var stars = starsContainer.querySelectorAll('.rating-star');
  var ratingCounter = document.querySelector('.rating-count');
  var ajaxHandler = new _ajaxHandler["default"]({
    'url': '/wp-admin/admin-ajax.php'
  });
  stars.forEach(function (star) {
    var rate = star.getAttribute('data-rate');
    var data = new FormData();
    data.append('action', 'rating');
    data.append('rate', rate);
    data.append('id', postId);
    data.append('page', window.location.href.split('?')[0]);
    star.addEventListener('click', function () {
      ajaxHandler.send(data, function () {
        var response = ajaxHandler.response;
        starsContainer.classList.add('disabled');

        _jsCookie["default"].set('rated-post-' + postId, rate, {
          expires: 365,
          path: '/'
        });

        if (ratingCounter) ratingCounter.textContent = response.count;
        stars.forEach(function (star) {
          if (rate >= parseInt(star.getAttribute('data-rate'), 10)) {
            star.classList.add('full');
          } else if (star.classList.contains('full')) {
            star.classList.remove('full');
          }
        });
      });
    });
  });
}

},{"../modules/ajax-handler":17,"js-cookie":1}],15:[function(require,module,exports){
"use strict";

var header = document.querySelector('.header');
var body = document.body;
var headerHeight = header.clientHeight;
var feedbackBtnWrap = document.querySelector('.feedback-btn-wrap');
window.addEventListener('scroll', function () {
  if (window.scrollY >= headerHeight) {
    header.classList.add('fixed');
    body.style.paddingTop = headerHeight + 'px';

    if (feedbackBtnWrap) {
      feedbackBtnWrap.classList.add('visible');
    }
  } else {
    header.classList.remove('fixed');
    body.style.paddingTop = '0';

    if (feedbackBtnWrap) {
      feedbackBtnWrap.classList.remove('visible');
    }
  }
});

},{}],16:[function(require,module,exports){
"use strict";

var _tooltip = _interopRequireDefault(require("../modules/tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

document.querySelectorAll('.tooltip').forEach(function (item) {
  new _tooltip["default"](item).init();
});

},{"../modules/tooltip":20}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AjaxHandler = /*#__PURE__*/function () {
  function AjaxHandler(options) {
    _classCallCheck(this, AjaxHandler);

    this.options = options;
    this.form = this.options.form;
    this.loader = this.form ? this.form.querySelector('.loader') : null;
    this.btn = this.form ? this.form.querySelector('button[type="submit"]') : null;
  }

  _createClass(AjaxHandler, [{
    key: "onResponseSuccess",
    value: function onResponseSuccess(callback) {
      if (callback) {
        callback();
      }
    }
  }, {
    key: "onResponseFalse",
    value: function onResponseFalse(callback) {
      if (callback) {
        callback();
      }
    }
  }, {
    key: "onAjaxHandlerProcess",
    value: function onAjaxHandlerProcess(callback) {
      if (callback) {
        callback();
      }
    }
  }, {
    key: "send",
    value: function send(data, callbackSuccess, callbackFalse, callbackProcess) {
      var _this = this;

      // Event to modify data before ajax sending
      var beforeSubmitEvent;

      if (this.form) {
        beforeSubmitEvent = new CustomEvent('ajax:beforeSubmit', {
          'detail': {
            formData: data
          }
        });
        this.form.dispatchEvent(beforeSubmitEvent);
      }

      var xhr = new XMLHttpRequest();
      xhr.open('POST', this.options.url, true);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.send(beforeSubmitEvent ? beforeSubmitEvent.detail.formData : data);

      this._disableBtn();

      this._showLoader();

      xhr.onreadystatechange = function () {
        if (xhr.readyState === xhr.DONE && xhr.status === 200) {
          _this._enableBtn();

          _this._hideLoader();

          var response = JSON.parse(xhr.responseText);
          _this.response = response;

          if (response.status === 'error') {
            _this.onResponseFalse(callbackFalse);
          } else {
            _this.onResponseSuccess(callbackSuccess);
          }
        }
      };
    }
  }, {
    key: "_disableBtn",
    value: function _disableBtn() {
      if (this.btn) {
        this.btn.setAttribute('disabled', 'disabled');
      }
    }
  }, {
    key: "_enableBtn",
    value: function _enableBtn() {
      if (this.btn) {
        this.btn.removeAttribute('disabled');
      }
    }
  }, {
    key: "_hideLoader",
    value: function _hideLoader() {
      if (this.loader) {
        this.loader.style.display = 'none';
      }
    }
  }, {
    key: "_showLoader",
    value: function _showLoader() {
      if (this.loader) {
        this.loader.style.display = 'block';
      }
    }
  }]);

  return AjaxHandler;
}();

var _default = AjaxHandler;
exports["default"] = _default;

},{}],18:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

window.dataLayer = window.dataLayer || [];

window.gtag = function () {
  dataLayer.push(arguments);
};
/**
 * @param {String} ymGoal
 * @param {Object} gaGoal
 * @param {String} fbGoal
 * @param {Object} ga4Goal
 * @param {String} vkGoal
 * @param {String} vkEvent
 */


module.exports.reachGoals = function (ymGoal, gaGoal, ga4Goal, fbGoal, vkGoal, vkEvent) {
  var ymCounterTag = document.getElementById('yandex-counter');
  var ymCounterNumber = ymCounterTag ? ymCounterTag.getAttribute('content') : '';
  var ym = 'yaCounter' + ymCounterNumber;
  var gaGoalIsSet = typeof gaGoal.label !== 'undefined' && typeof gaGoal.action !== 'undefined' && typeof gaGoal.category !== 'undefined';

  var findCounter = function findCounter(i) {
    if (window[ym] === undefined) {
      i--;
      setTimeout(function () {
        return findCounter(i);
      }, 300);
    } else if (typeof ymCounterNumber !== 'undefined' && ymCounterNumber.length && typeof ymGoal !== 'undefined') {
      window[ym].reachGoal(ymGoal);

      if (gaGoalIsSet) {
        window.yaParams = _defineProperty({}, gaGoal.category, _defineProperty({}, gaGoal.action, _defineProperty({}, gaGoal.label, [window.location.href.split('?')[0]])));
        window[ym].params(window.yaParams || {});
      }
    }
  };

  findCounter(10);

  if (typeof ga !== 'undefined' && gaGoalIsSet) {
    ga('send', 'event', gaGoal.category, gaGoal.action, gaGoal.label);
  }

  if (typeof fbq !== 'undefined' && fbGoal) {
    fbq('track', fbGoal);
  }

  if (typeof gtag !== 'undefined' && typeof ga4Goal !== 'undefined' && ga4Goal.id !== '') {
    var $params = {};

    if (ga4Goal.params) {
      ga4Goal.params.forEach(function (param) {
        $params[param.key] = param.type === 'number' ? Number(param.value) : param.value;
      });
    }

    gtag("event", ga4Goal.id, $params);
  }

  if ((typeof VK === "undefined" ? "undefined" : _typeof(VK)) === 'object') {
    VK.Goal(vkGoal);
  }

  if ((typeof VK === "undefined" ? "undefined" : _typeof(VK)) === 'object' && VK.Retargeting) {
    VK.Retargeting.Event(vkEvent);
  }
};

},{}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ajaxHandler = _interopRequireDefault(require("./ajax-handler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LoadMore = /*#__PURE__*/function () {
  function LoadMore(btn) {
    _classCallCheck(this, LoadMore);

    var attributes = btn.attributes;
    /**
     * Options array
     *   termId
     *   postType
     *   numberposts
     *   offset
     *
     * Usage: 'data-loadmore-%option%="%value%"'
     * NB: %option% should be written in kebab-case (postType => data-loadmore-post-type)
     *
     * @type {{action: string}}
     */

    this.options = {
      'action': 'load_more'
    };

    for (var i = attributes.length - 1; i >= 0; i--) {
      if (attributes[i].name.indexOf('data-loadmore-') === -1) continue;
      var attributeName = attributes[i].name.replace('data-loadmore-', '').split('-').reduce(function (finalName, namePart, index) {
        return finalName + (index === 0 ? namePart : namePart.charAt(0).toUpperCase() + namePart.slice(1));
      });
      this.options[attributeName] = attributes[i].value;
    }

    this.options['offset'] = this.options['offset'] || this.options['numberposts'] || '';
    this.btn = btn;
    this.ajaxContainer = this.btn.closest('.loadmore-wrap').querySelector('.loadmore-container');

    this._setListeners();
  }

  _createClass(LoadMore, [{
    key: "_setListeners",
    value: function _setListeners() {
      var _this = this;

      this.btn.addEventListener('click', function () {
        return _this._load();
      });
    }
  }, {
    key: "_load",
    value: function _load() {
      var _this2 = this;

      var data = new FormData();

      for (var prop in this.options) {
        data.append(prop, this.options[prop]);
      }

      var ajaxHandler = new _ajaxHandler["default"]({
        'url': '/wp-admin/admin-ajax.php'
      });
      ajaxHandler.send(data, function () {
        var response = ajaxHandler.response;

        _this2.ajaxContainer.insertAdjacentHTML('beforeend', response.posts);

        if (response['morePosts']) {
          _this2.options['offset'] = response['currentOffset'];
        } else {
          _this2.btn.style.display = 'none';
        }
      });
    }
  }]);

  return LoadMore;
}();

var _default = LoadMore;
exports["default"] = _default;

},{"./ajax-handler":17}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Tooltip = /*#__PURE__*/function () {
  function Tooltip(tooltip) {
    _classCallCheck(this, Tooltip);

    this.parent = tooltip.closest('.tooltip-parent');
    this.tooltip = tooltip;
    this.tooltipOffset = 10;
    this.tooltipLeaveTime = 500;
  }

  _createClass(Tooltip, [{
    key: "init",
    value: function init() {
      this._setEventListeners();

      if (this.tooltip.classList.contains('visible')) {
        this._calculateTooltipDimensions();
      }
    }
  }, {
    key: "recalculate",
    value: function recalculate() {
      if (this.tooltip) {
        this._calculateTooltipDimensions();
      }
    }
  }, {
    key: "_calculateOnHover",
    value: function _calculateOnHover() {
      this._calculateTooltipDimensions();

      this.tooltip.classList.add('visible');
    }
  }, {
    key: "_setEventListeners",
    value: function _setEventListeners() {
      var _this = this;

      this.parent.addEventListener('mouseenter', function () {
        _this._calculateOnHover();

        _this._hovered = true;
      });
      this.parent.addEventListener('mouseleave', function () {
        _this._hovered = false;
        setTimeout(function () {
          if (!_this._hovered) {
            _this.tooltip.classList.remove('visible');

            setTimeout(function () {
              _this.tooltip.classList.remove('active');
            }, 300);
          }
        }, _this.tooltipLeaveTime);
      });
    }
  }, {
    key: "_calculateTooltipDimensions",
    value: function _calculateTooltipDimensions() {
      this.tooltip.classList.add('active');
      this.tooltip.classList.remove('tooltip--top');
      this.tooltip.style.top = null;
      this.tooltip.style.left = null;
      var windowHeight = window.innerHeight;
      var windowWidth = window.innerWidth;
      var tooltip = this.tooltip;
      tooltip.style.maxWidth = windowWidth - 60 + 'px';
      var tooltipRect = tooltip.getBoundingClientRect();
      var parentRect = this.parent.getBoundingClientRect();
      var left = 0;
      if (parentRect.left + parentRect.width + tooltipRect.width > windowWidth) left = -tooltipRect.width + parentRect.width;
      var top = parentRect.height + this.tooltipOffset;

      if (tooltipRect.height + parentRect.height + parentRect.top + this.tooltipOffset > windowHeight) {
        top = -tooltipRect.height - this.tooltipOffset;
        tooltip.classList.add('tooltip--top');
      }

      tooltip.style.top = top + 'px';
      tooltip.style.left = left + 'px';
    }
  }]);

  return Tooltip;
}();

var _default = Tooltip;
exports["default"] = _default;

},{}],21:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * Glide.js v3.3.0
 * (c) 2013-2019 Jędrzej Chałubek <jedrzej.chalubek@gmail.com> (http://jedrzejchalubek.com/)
 * Released under the MIT License.
 */
!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.Glide = e();
}(void 0, function () {
  "use strict";

  var n = {
    type: "slider",
    startAt: 0,
    perView: 1,
    focusAt: 0,
    gap: 10,
    autoplay: !1,
    hoverpause: !0,
    keyboard: !0,
    bound: !1,
    swipeThreshold: 80,
    dragThreshold: 120,
    perSwipe: "|",
    touchRatio: .5,
    touchAngle: 45,
    animationDuration: 400,
    rewind: !0,
    rewindDuration: 800,
    animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
    waitForTransition: !0,
    throttle: 10,
    direction: "ltr",
    peek: 0,
    breakpoints: {},
    classes: {
      swipeable: "glide--swipeable",
      dragging: "glide--dragging",
      direction: {
        ltr: "glide--ltr",
        rtl: "glide--rtl"
      },
      type: {
        slider: "glide--slider",
        carousel: "glide--carousel"
      },
      slide: {
        clone: "glide__slide--clone",
        active: "glide__slide--active"
      },
      arrow: {
        disabled: "glide__arrow--disabled"
      },
      nav: {
        active: "glide__bullet--active"
      }
    }
  };

  function i(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }

  var r = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  },
      t = function t(_t, e, n) {
    return e && s(_t.prototype, e), n && s(_t, n), _t;
  };

  function s(t, e) {
    for (var n = 0; n < e.length; n++) {
      var i = e[n];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }

  var a = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var i in n) {
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
      }
    }

    return t;
  };

  function y(t) {
    return parseInt(t);
  }

  function o(t) {
    return "string" == typeof t;
  }

  function u(t) {
    var e = void 0 === t ? "undefined" : r(t);
    return "function" === e || "object" === e && !!t;
  }

  function c(t) {
    return "function" == typeof t;
  }

  function l(t) {
    return void 0 === t;
  }

  function f(t) {
    return t.constructor === Array;
  }

  function d(t, e, n) {
    Object.defineProperty(t, e, n);
  }

  function h(t, e) {
    var n = a({}, t, e);
    return e.hasOwnProperty("classes") && (n.classes = a({}, t.classes, e.classes), e.classes.hasOwnProperty("direction") && (n.classes.direction = a({}, t.classes.direction, e.classes.direction)), e.classes.hasOwnProperty("type") && (n.classes.type = a({}, t.classes.type, e.classes.type)), e.classes.hasOwnProperty("slide") && (n.classes.slide = a({}, t.classes.slide, e.classes.slide)), e.classes.hasOwnProperty("arrow") && (n.classes.arrow = a({}, t.classes.arrow, e.classes.arrow)), e.classes.hasOwnProperty("nav") && (n.classes.nav = a({}, t.classes.nav, e.classes.nav))), e.hasOwnProperty("breakpoints") && (n.breakpoints = a({}, t.breakpoints, e.breakpoints)), n;
  }

  var v = (t(e, [{
    key: "on",
    value: function value(t, e) {
      if (f(t)) for (var n = 0; n < t.length; n++) {
        this.on(t[n], e);
      }
      this.hop.call(this.events, t) || (this.events[t] = []);
      var i = this.events[t].push(e) - 1;
      return {
        remove: function remove() {
          delete this.events[t][i];
        }
      };
    }
  }, {
    key: "emit",
    value: function value(t, e) {
      if (f(t)) for (var n = 0; n < t.length; n++) {
        this.emit(t[n], e);
      }
      this.hop.call(this.events, t) && this.events[t].forEach(function (t) {
        t(e || {});
      });
    }
  }]), e);

  function e() {
    var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
    i(this, e), this.events = t, this.hop = t.hasOwnProperty;
  }

  var p = (t(m, [{
    key: "mount",
    value: function value(t) {
      var e = 0 < arguments.length && void 0 !== t ? t : {};
      return this._e.emit("mount.before"), u(e) && (this._c = function (t, e, n) {
        var i = {};

        for (var r in e) {
          c(e[r]) && (i[r] = e[r](t, i, n));
        }

        for (var s in i) {
          c(i[s].mount) && i[s].mount();
        }

        return i;
      }(this, e, this._e)), this._e.emit("mount.after"), this;
    }
  }, {
    key: "mutate",
    value: function value(t) {
      var e = 0 < arguments.length && void 0 !== t ? t : [];
      return f(e) && (this._t = e), this;
    }
  }, {
    key: "update",
    value: function value(t) {
      var e = 0 < arguments.length && void 0 !== t ? t : {};
      return this.settings = h(this.settings, e), e.hasOwnProperty("startAt") && (this.index = e.startAt), this._e.emit("update"), this;
    }
  }, {
    key: "go",
    value: function value(t) {
      return this._c.Run.make(t), this;
    }
  }, {
    key: "move",
    value: function value(t) {
      return this._c.Transition.disable(), this._c.Move.make(t), this;
    }
  }, {
    key: "destroy",
    value: function value() {
      return this._e.emit("destroy"), this;
    }
  }, {
    key: "play",
    value: function value(t) {
      var e = 0 < arguments.length && void 0 !== t && t;
      return e && (this.settings.autoplay = e), this._e.emit("play"), this;
    }
  }, {
    key: "pause",
    value: function value() {
      return this._e.emit("pause"), this;
    }
  }, {
    key: "disable",
    value: function value() {
      return this.disabled = !0, this;
    }
  }, {
    key: "enable",
    value: function value() {
      return this.disabled = !1, this;
    }
  }, {
    key: "on",
    value: function value(t, e) {
      return this._e.on(t, e), this;
    }
  }, {
    key: "isType",
    value: function value(t) {
      return this.settings.type === t;
    }
  }, {
    key: "settings",
    get: function get() {
      return this._o;
    },
    set: function set(t) {
      u(t) && (this._o = t);
    }
  }, {
    key: "index",
    get: function get() {
      return this._i;
    },
    set: function set(t) {
      this._i = y(t);
    }
  }, {
    key: "type",
    get: function get() {
      return this.settings.type;
    }
  }, {
    key: "disabled",
    get: function get() {
      return this._d;
    },
    set: function set(t) {
      this._d = !!t;
    }
  }]), m);

  function m(t) {
    var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
    i(this, m), this._c = {}, this._t = [], this._e = new v(), this.disabled = !1, this.selector = t, this.settings = h(n, e), this.index = this.settings.startAt;
  }

  function g() {
    return new Date().getTime();
  }

  function b(n, i, r) {
    var s = void 0,
        o = void 0,
        u = void 0,
        a = void 0,
        c = 0;
    r = r || {};

    function l() {
      c = !1 === r.leading ? 0 : g(), s = null, a = n.apply(o, u), s || (o = u = null);
    }

    function t() {
      var t = g();
      c || !1 !== r.leading || (c = t);
      var e = i - (t - c);
      return o = this, u = arguments, e <= 0 || i < e ? (s && (clearTimeout(s), s = null), c = t, a = n.apply(o, u), s || (o = u = null)) : s || !1 === r.trailing || (s = setTimeout(l, e)), a;
    }

    return t.cancel = function () {
      clearTimeout(s), c = 0, s = o = u = null;
    }, t;
  }

  var w = {
    ltr: ["marginLeft", "marginRight"],
    rtl: ["marginRight", "marginLeft"]
  };

  function _(t) {
    if (t && t.parentNode) {
      for (var e = t.parentNode.firstChild, n = []; e; e = e.nextSibling) {
        1 === e.nodeType && e !== t && n.push(e);
      }

      return n;
    }

    return [];
  }

  function k(t) {
    return !!(t && t instanceof window.HTMLElement);
  }

  var S = '[data-glide-el="track"]';
  var H = (t(T, [{
    key: "on",
    value: function value(t, e, n, i) {
      var r = 3 < arguments.length && void 0 !== i && i;
      o(t) && (t = [t]);

      for (var s = 0; s < t.length; s++) {
        this.listeners[t[s]] = n, e.addEventListener(t[s], this.listeners[t[s]], r);
      }
    }
  }, {
    key: "off",
    value: function value(t, e, n) {
      var i = 2 < arguments.length && void 0 !== n && n;
      o(t) && (t = [t]);

      for (var r = 0; r < t.length; r++) {
        e.removeEventListener(t[r], this.listeners[t[r]], i);
      }
    }
  }, {
    key: "destroy",
    value: function value() {
      delete this.listeners;
    }
  }]), T);

  function T() {
    var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
    i(this, T), this.listeners = t;
  }

  var O = ["ltr", "rtl"],
      x = {
    ">": "<",
    "<": ">",
    "=": "="
  };

  function A(t, e) {
    return {
      modify: function modify(t) {
        return e.Direction.is("rtl") ? -t : t;
      }
    };
  }

  function P(i, r, s) {
    var o = [function (t, n) {
      return {
        modify: function modify(t) {
          var e = Math.floor(t / n.Sizes.slideWidth);
          return t + n.Gaps.value * e;
        }
      };
    }, function (t, e) {
      return {
        modify: function modify(t) {
          return t + e.Clones.grow / 2;
        }
      };
    }, function (n, i) {
      return {
        modify: function modify(t) {
          if (0 <= n.settings.focusAt) {
            var e = i.Peek.value;
            return u(e) ? t - e.before : t - e;
          }

          return t;
        }
      };
    }, function (s, o) {
      return {
        modify: function modify(t) {
          var e = o.Gaps.value,
              n = o.Sizes.width,
              i = s.settings.focusAt,
              r = o.Sizes.slideWidth;
          return "center" === i ? t - (n / 2 - r / 2) : t - r * i - e * i;
        }
      };
    }].concat(i._t, [A]);
    return {
      mutate: function mutate(t) {
        for (var e = 0; e < o.length; e++) {
          var n = o[e];
          c(n) && c(n().modify) && (t = n(i, r, s).modify(t));
        }

        return t;
      }
    };
  }

  var M = !1;

  try {
    var z = Object.defineProperty({}, "passive", {
      get: function get() {
        M = !0;
      }
    });
    window.addEventListener("testPassive", null, z), window.removeEventListener("testPassive", null, z);
  } catch (t) {}

  var C = M,
      L = ["touchstart", "mousedown"],
      R = ["touchmove", "mousemove"],
      D = ["touchend", "touchcancel", "mouseup", "mouseleave"],
      E = ["mousedown", "mousemove", "mouseup", "mouseleave"];

  function j(t) {
    return u(t) ? function (n) {
      return Object.keys(n).sort().reduce(function (t, e) {
        return t[e] = n[e], t[e], t;
      }, {});
    }(t) : {};
  }

  var W = {
    Html: function Html(e, t) {
      var n = {
        mount: function mount() {
          this.root = e.selector, this.track = this.root.querySelector(S), this.slides = Array.prototype.slice.call(this.wrapper.children).filter(function (t) {
            return !t.classList.contains(e.settings.classes.slide.clone);
          });
        }
      };
      return d(n, "root", {
        get: function get() {
          return n._r;
        },
        set: function set(t) {
          o(t) && (t = document.querySelector(t)), k(t) && (n._r = t);
        }
      }), d(n, "track", {
        get: function get() {
          return n._t;
        },
        set: function set(t) {
          k(t) && (n._t = t);
        }
      }), d(n, "wrapper", {
        get: function get() {
          return n.track.children[0];
        }
      }), n;
    },
    Translate: function Translate(i, r, n) {
      var s = {
        set: function set(t) {
          var e = P(i, r).mutate(t);
          r.Html.wrapper.style.transform = "translate3d(" + -1 * e + "px, 0px, 0px)";
        },
        remove: function remove() {
          r.Html.wrapper.style.transform = "";
        },
        getStartIndex: function getStartIndex() {
          var t = r.Sizes.length,
              e = i.index,
              n = i.settings.perView;
          return r.Run.isOffset(">") || r.Run.isOffset("|>") ? t + (e - n) : (e + n) % t;
        },
        getTravelDistance: function getTravelDistance() {
          var t = r.Sizes.slideWidth * i.settings.perView;
          return r.Run.isOffset(">") || r.Run.isOffset("|>") ? -1 * t : t;
        }
      };
      return n.on("move", function (t) {
        if (!i.isType("carousel") || !r.Run.isOffset()) return s.set(t.movement);
        r.Transition.after(function () {
          n.emit("translate.jump"), s.set(r.Sizes.slideWidth * i.index);
        });
        var e = r.Sizes.slideWidth * r.Translate.getStartIndex();
        return s.set(e - r.Translate.getTravelDistance());
      }), n.on("destroy", function () {
        s.remove();
      }), s;
    },
    Transition: function Transition(n, i, t) {
      var r = !1,
          e = {
        compose: function compose(t) {
          var e = n.settings;
          return r ? t + " 0ms " + e.animationTimingFunc : t + " " + this.duration + "ms " + e.animationTimingFunc;
        },
        set: function set(t) {
          var e = 0 < arguments.length && void 0 !== t ? t : "transform";
          i.Html.wrapper.style.transition = this.compose(e);
        },
        remove: function remove() {
          i.Html.wrapper.style.transition = "";
        },
        after: function after(t) {
          setTimeout(function () {
            t();
          }, this.duration);
        },
        enable: function enable() {
          r = !1, this.set();
        },
        disable: function disable() {
          r = !0, this.set();
        }
      };
      return d(e, "duration", {
        get: function get() {
          var t = n.settings;
          return n.isType("slider") && i.Run.offset ? t.rewindDuration : t.animationDuration;
        }
      }), t.on("move", function () {
        e.set();
      }), t.on(["build.before", "resize", "translate.jump"], function () {
        e.disable();
      }), t.on("run", function () {
        e.enable();
      }), t.on("destroy", function () {
        e.remove();
      }), e;
    },
    Direction: function Direction(t, e, n) {
      var i = {
        mount: function mount() {
          this.value = t.settings.direction;
        },
        resolve: function resolve(t) {
          var e = t.slice(0, 1);
          return this.is("rtl") ? t.split(e).join(x[e]) : t;
        },
        is: function is(t) {
          return this.value === t;
        },
        addClass: function addClass() {
          e.Html.root.classList.add(t.settings.classes.direction[this.value]);
        },
        removeClass: function removeClass() {
          e.Html.root.classList.remove(t.settings.classes.direction[this.value]);
        }
      };
      return d(i, "value", {
        get: function get() {
          return i._v;
        },
        set: function set(t) {
          -1 < O.indexOf(t) && (i._v = t);
        }
      }), n.on(["destroy", "update"], function () {
        i.removeClass();
      }), n.on("update", function () {
        i.mount();
      }), n.on(["build.before", "update"], function () {
        i.addClass();
      }), i;
    },
    Peek: function Peek(n, t, e) {
      var i = {
        mount: function mount() {
          this.value = n.settings.peek;
        }
      };
      return d(i, "value", {
        get: function get() {
          return i._v;
        },
        set: function set(t) {
          u(t) ? (t.before = y(t.before), t.after = y(t.after)) : t = y(t), i._v = t;
        }
      }), d(i, "reductor", {
        get: function get() {
          var t = i.value,
              e = n.settings.perView;
          return u(t) ? t.before / e + t.after / e : 2 * t / e;
        }
      }), e.on(["resize", "update"], function () {
        i.mount();
      }), i;
    },
    Sizes: function Sizes(t, i, e) {
      var n = {
        setupSlides: function setupSlides() {
          for (var t = this.slideWidth + "px", e = i.Html.slides, n = 0; n < e.length; n++) {
            e[n].style.width = t;
          }
        },
        setupWrapper: function setupWrapper() {
          i.Html.wrapper.style.width = this.wrapperSize + "px";
        },
        remove: function remove() {
          for (var t = i.Html.slides, e = 0; e < t.length; e++) {
            t[e].style.width = "";
          }

          i.Html.wrapper.style.width = "";
        }
      };
      return d(n, "length", {
        get: function get() {
          return i.Html.slides.length;
        }
      }), d(n, "width", {
        get: function get() {
          return i.Html.root.offsetWidth;
        }
      }), d(n, "wrapperSize", {
        get: function get() {
          return n.slideWidth * n.length + i.Gaps.grow + i.Clones.grow;
        }
      }), d(n, "slideWidth", {
        get: function get() {
          return n.width / t.settings.perView - i.Peek.reductor - i.Gaps.reductor;
        }
      }), e.on(["build.before", "resize", "update"], function () {
        n.setupSlides(), n.setupWrapper();
      }), e.on("destroy", function () {
        n.remove();
      }), n;
    },
    Gaps: function Gaps(e, s, t) {
      var n = {
        apply: function apply(t) {
          for (var e = 0, n = t.length; e < n; e++) {
            var i = t[e].style,
                r = s.Direction.value;
            i[w[r][0]] = 0 !== e ? this.value / 2 + "px" : "", e !== t.length - 1 ? i[w[r][1]] = this.value / 2 + "px" : i[w[r][1]] = "";
          }
        },
        remove: function remove(t) {
          for (var e = 0, n = t.length; e < n; e++) {
            var i = t[e].style;
            i.marginLeft = "", i.marginRight = "";
          }
        }
      };
      return d(n, "value", {
        get: function get() {
          return y(e.settings.gap);
        }
      }), d(n, "grow", {
        get: function get() {
          return n.value * s.Sizes.length;
        }
      }), d(n, "reductor", {
        get: function get() {
          var t = e.settings.perView;
          return n.value * (t - 1) / t;
        }
      }), t.on(["build.after", "update"], b(function () {
        n.apply(s.Html.wrapper.children);
      }, 30)), t.on("destroy", function () {
        n.remove(s.Html.wrapper.children);
      }), n;
    },
    Move: function Move(t, i, r) {
      var e = {
        mount: function mount() {
          this._o = 0;
        },
        make: function make(t) {
          var e = this,
              n = 0 < arguments.length && void 0 !== t ? t : 0;
          this.offset = n, r.emit("move", {
            movement: this.value
          }), i.Transition.after(function () {
            r.emit("move.after", {
              movement: e.value
            });
          });
        }
      };
      return d(e, "offset", {
        get: function get() {
          return e._o;
        },
        set: function set(t) {
          e._o = l(t) ? 0 : y(t);
        }
      }), d(e, "translate", {
        get: function get() {
          return i.Sizes.slideWidth * t.index;
        }
      }), d(e, "value", {
        get: function get() {
          var t = this.offset,
              e = this.translate;
          return i.Direction.is("rtl") ? e + t : e - t;
        }
      }), r.on(["build.before", "run"], function () {
        e.make();
      }), e;
    },
    Clones: function Clones(v, p, t) {
      var e = {
        mount: function mount() {
          this.items = [], v.isType("carousel") && (this.items = this.collect());
        },
        collect: function collect(t) {
          for (var e = 0 < arguments.length && void 0 !== t ? t : [], n = p.Html.slides, i = v.settings, r = i.perView, s = i.classes, o = r + +!!v.settings.peek + Math.round(r / 2), u = n.slice(0, o).reverse(), a = n.slice(-1 * o), c = 0; c < Math.max(1, Math.floor(r / n.length)); c++) {
            for (var l = 0; l < u.length; l++) {
              var f = u[l].cloneNode(!0);
              f.classList.add(s.slide.clone), e.push(f);
            }

            for (var d = 0; d < a.length; d++) {
              var h = a[d].cloneNode(!0);
              h.classList.add(s.slide.clone), e.unshift(h);
            }
          }

          return e;
        },
        append: function append() {
          for (var t = this.items, e = p.Html, n = e.wrapper, i = e.slides, r = Math.floor(t.length / 2), s = t.slice(0, r).reverse(), o = t.slice(-1 * r).reverse(), u = p.Sizes.slideWidth + "px", a = 0; a < o.length; a++) {
            n.appendChild(o[a]);
          }

          for (var c = 0; c < s.length; c++) {
            n.insertBefore(s[c], i[0]);
          }

          for (var l = 0; l < t.length; l++) {
            t[l].style.width = u;
          }
        },
        remove: function remove() {
          for (var t = this.items, e = 0; e < t.length; e++) {
            p.Html.wrapper.removeChild(t[e]);
          }
        }
      };
      return d(e, "grow", {
        get: function get() {
          return (p.Sizes.slideWidth + p.Gaps.value) * e.items.length;
        }
      }), t.on("update", function () {
        e.remove(), e.mount(), e.append();
      }), t.on("build.before", function () {
        v.isType("carousel") && e.append();
      }), t.on("destroy", function () {
        e.remove();
      }), e;
    },
    Resize: function Resize(t, e, n) {
      var i = new H(),
          r = {
        mount: function mount() {
          this.bind();
        },
        bind: function bind() {
          i.on("resize", window, b(function () {
            n.emit("resize");
          }, t.settings.throttle));
        },
        unbind: function unbind() {
          i.off("resize", window);
        }
      };
      return n.on("destroy", function () {
        r.unbind(), i.destroy();
      }), r;
    },
    Build: function Build(i, r, t) {
      var e = {
        mount: function mount() {
          t.emit("build.before"), this.typeClass(), this.activeClass(), t.emit("build.after");
        },
        typeClass: function typeClass() {
          r.Html.root.classList.add(i.settings.classes.type[i.settings.type]);
        },
        activeClass: function activeClass() {
          var e = i.settings.classes,
              t = r.Html.slides[i.index];
          t && (t.classList.add(e.slide.active), _(t).forEach(function (t) {
            t.classList.remove(e.slide.active);
          }));
        },
        removeClasses: function removeClasses() {
          var t = i.settings.classes,
              e = t.type,
              n = t.slide;
          r.Html.root.classList.remove(e[i.settings.type]), r.Html.slides.forEach(function (t) {
            t.classList.remove(n.active);
          });
        }
      };
      return t.on(["destroy", "update"], function () {
        e.removeClasses();
      }), t.on(["resize", "update"], function () {
        e.mount();
      }), t.on("move.after", function () {
        e.activeClass();
      }), e;
    },
    Run: function Run(u, n, i) {
      var a = {
        mount: function mount() {
          this._o = !1;
        },
        make: function make(t) {
          var e = this;
          u.disabled || (u.settings.waitForTransition && u.disable(), this.move = t, i.emit("run.before", this.move), this.calculate(), i.emit("run", this.move), n.Transition.after(function () {
            e.isStart() && i.emit("run.start", e.move), e.isEnd() && i.emit("run.end", e.move), e.isOffset() && (e._o = !1, i.emit("run.offset", e.move)), i.emit("run.after", e.move), u.enable();
          }));
        },
        calculate: function calculate() {
          var t = this.move,
              e = this.length,
              n = t.steps,
              i = t.direction,
              r = 1;
          if ("=" !== i) {
            if (">" !== i || ">" !== n) {
              if ("<" !== i || "<" !== n) {
                if ("|" === i && (r = u.settings.perView || 1), ">" === i || "|" === i && ">" === n) {
                  var s = function (t) {
                    var e = u.index;
                    if (u.isType("carousel")) return e + t;
                    return e + (t - e % t);
                  }(r);

                  return e < s && (this._o = !0), void (u.index = function (t, e) {
                    var n = a.length;
                    if (t <= n) return t;
                    if (u.isType("carousel")) return t - (n + 1);
                    if (u.settings.rewind) return a.isBound() && !a.isEnd() ? n : 0;
                    if (a.isBound()) return n;
                    return Math.floor(n / e) * e;
                  }(s, r));
                }

                if ("<" === i || "|" === i && "<" === n) {
                  var o = function (t) {
                    var e = u.index;
                    if (u.isType("carousel")) return e - t;
                    return (Math.ceil(e / t) - 1) * t;
                  }(r);

                  return o < 0 && (this._o = !0), void (u.index = function (t, e) {
                    var n = a.length;
                    if (0 <= t) return t;
                    if (u.isType("carousel")) return t + (n + 1);
                    if (u.settings.rewind) return a.isBound() && a.isStart() ? n : Math.floor(n / e) * e;
                    return 0;
                  }(o, r));
                }
              } else u.index = 0;
            } else u.index = e;
          } else u.index = n;
        },
        isStart: function isStart() {
          return u.index <= 0;
        },
        isEnd: function isEnd() {
          return u.index >= this.length;
        },
        isOffset: function isOffset(t) {
          var e = 0 < arguments.length && void 0 !== t ? t : void 0;
          return e ? !!this._o && ("|>" === e ? "|" === this.move.direction && ">" === this.move.steps : "|<" === e ? "|" === this.move.direction && "<" === this.move.steps : this.move.direction === e) : this._o;
        },
        isBound: function isBound() {
          return u.isType("slider") && "center" !== u.settings.focusAt && u.settings.bound;
        }
      };
      return d(a, "move", {
        get: function get() {
          return this._m;
        },
        set: function set(t) {
          var e = t.substr(1);
          this._m = {
            direction: t.substr(0, 1),
            steps: e ? y(e) ? y(e) : e : 0
          };
        }
      }), d(a, "length", {
        get: function get() {
          var t = u.settings,
              e = n.Html.slides.length;
          return this.isBound() ? e - 1 - (y(t.perView) - 1) + y(t.focusAt) : e - 1;
        }
      }), d(a, "offset", {
        get: function get() {
          return this._o;
        }
      }), a;
    },
    Swipe: function Swipe(d, h, v) {
      var r = new H(),
          p = 0,
          m = 0,
          g = 0,
          n = !1,
          s = !!C && {
        passive: !0
      },
          t = {
        mount: function mount() {
          this.bindSwipeStart();
        },
        start: function start(t) {
          if (!n && !d.disabled) {
            this.disable();
            var e = this.touches(t);
            p = null, m = y(e.pageX), g = y(e.pageY), this.bindSwipeMove(), this.bindSwipeEnd(), v.emit("swipe.start");
          }
        },
        move: function move(t) {
          if (!d.disabled) {
            var e = d.settings,
                n = e.touchAngle,
                i = e.touchRatio,
                r = e.classes,
                s = this.touches(t),
                o = y(s.pageX) - m,
                u = y(s.pageY) - g,
                a = Math.abs(o << 2),
                c = Math.abs(u << 2),
                l = Math.sqrt(a + c),
                f = Math.sqrt(c);
            if (!(180 * (p = Math.asin(f / l)) / Math.PI < n)) return !1;
            t.stopPropagation(), h.Move.make(o * function (t) {
              return parseFloat(t);
            }(i)), h.Html.root.classList.add(r.dragging), v.emit("swipe.move");
          }
        },
        end: function end(t) {
          if (!d.disabled) {
            var e = d.settings,
                n = e.perSwipe,
                i = e.touchAngle,
                r = e.classes,
                s = this.touches(t),
                o = this.threshold(t),
                u = s.pageX - m,
                a = 180 * p / Math.PI;
            this.enable(), o < u && a < i ? h.Run.make(h.Direction.resolve(n + "<")) : u < -o && a < i ? h.Run.make(h.Direction.resolve(n + ">")) : h.Move.make(), h.Html.root.classList.remove(r.dragging), this.unbindSwipeMove(), this.unbindSwipeEnd(), v.emit("swipe.end");
          }
        },
        bindSwipeStart: function bindSwipeStart() {
          var e = this,
              t = d.settings,
              n = t.swipeThreshold,
              i = t.dragThreshold;
          n && r.on(L[0], h.Html.wrapper, function (t) {
            e.start(t);
          }, s), i && r.on(L[1], h.Html.wrapper, function (t) {
            e.start(t);
          }, s);
        },
        unbindSwipeStart: function unbindSwipeStart() {
          r.off(L[0], h.Html.wrapper, s), r.off(L[1], h.Html.wrapper, s);
        },
        bindSwipeMove: function bindSwipeMove() {
          var e = this;
          r.on(R, h.Html.wrapper, b(function (t) {
            e.move(t);
          }, d.settings.throttle), s);
        },
        unbindSwipeMove: function unbindSwipeMove() {
          r.off(R, h.Html.wrapper, s);
        },
        bindSwipeEnd: function bindSwipeEnd() {
          var e = this;
          r.on(D, h.Html.wrapper, function (t) {
            e.end(t);
          });
        },
        unbindSwipeEnd: function unbindSwipeEnd() {
          r.off(D, h.Html.wrapper);
        },
        touches: function touches(t) {
          return -1 < E.indexOf(t.type) ? t : t.touches[0] || t.changedTouches[0];
        },
        threshold: function threshold(t) {
          var e = d.settings;
          return -1 < E.indexOf(t.type) ? e.dragThreshold : e.swipeThreshold;
        },
        enable: function enable() {
          return n = !1, h.Transition.enable(), this;
        },
        disable: function disable() {
          return n = !0, h.Transition.disable(), this;
        }
      };
      return v.on("build.after", function () {
        h.Html.root.classList.add(d.settings.classes.swipeable);
      }), v.on("destroy", function () {
        t.unbindSwipeStart(), t.unbindSwipeMove(), t.unbindSwipeEnd(), r.destroy();
      }), t;
    },
    Images: function Images(t, e, n) {
      var i = new H(),
          r = {
        mount: function mount() {
          this.bind();
        },
        bind: function bind() {
          i.on("dragstart", e.Html.wrapper, this.dragstart);
        },
        unbind: function unbind() {
          i.off("dragstart", e.Html.wrapper);
        },
        dragstart: function dragstart(t) {
          t.preventDefault();
        }
      };
      return n.on("destroy", function () {
        r.unbind(), i.destroy();
      }), r;
    },
    Anchors: function Anchors(t, e, n) {
      var i = new H(),
          r = !1,
          s = !1,
          o = {
        mount: function mount() {
          this._a = e.Html.wrapper.querySelectorAll("a"), this.bind();
        },
        bind: function bind() {
          i.on("click", e.Html.wrapper, this.click);
        },
        unbind: function unbind() {
          i.off("click", e.Html.wrapper);
        },
        click: function click(t) {
          s && (t.stopPropagation(), t.preventDefault());
        },
        detach: function detach() {
          if (s = !0, !r) {
            for (var t = 0; t < this.items.length; t++) {
              this.items[t].draggable = !1, this.items[t].setAttribute("data-href", this.items[t].getAttribute("href")), this.items[t].removeAttribute("href");
            }

            r = !0;
          }

          return this;
        },
        attach: function attach() {
          if (s = !1, r) {
            for (var t = 0; t < this.items.length; t++) {
              this.items[t].draggable = !0, this.items[t].setAttribute("href", this.items[t].getAttribute("data-href"));
            }

            r = !1;
          }

          return this;
        }
      };
      return d(o, "items", {
        get: function get() {
          return o._a;
        }
      }), n.on("swipe.move", function () {
        o.detach();
      }), n.on("swipe.end", function () {
        e.Transition.after(function () {
          o.attach();
        });
      }), n.on("destroy", function () {
        o.attach(), o.unbind(), i.destroy();
      }), o;
    },
    Controls: function Controls(i, e, t) {
      var n = new H(),
          r = !!C && {
        passive: !0
      },
          s = {
        mount: function mount() {
          this._n = e.Html.root.querySelectorAll('[data-glide-el="controls[nav]"]'), this._c = e.Html.root.querySelectorAll('[data-glide-el^="controls"]'), this.addBindings();
        },
        setActive: function setActive() {
          for (var t = 0; t < this._n.length; t++) {
            this.addClass(this._n[t].children);
          }
        },
        removeActive: function removeActive() {
          for (var t = 0; t < this._n.length; t++) {
            this.removeClass(this._n[t].children);
          }
        },
        addClass: function addClass(t) {
          var e = i.settings,
              n = t[i.index];
          n && (n.classList.add(e.classes.nav.active), _(n).forEach(function (t) {
            t.classList.remove(e.classes.nav.active);
          }));
        },
        removeClass: function removeClass(t) {
          var e = t[i.index];
          e && e.classList.remove(i.settings.classes.nav.active);
        },
        addBindings: function addBindings() {
          for (var t = 0; t < this._c.length; t++) {
            this.bind(this._c[t].children);
          }
        },
        removeBindings: function removeBindings() {
          for (var t = 0; t < this._c.length; t++) {
            this.unbind(this._c[t].children);
          }
        },
        bind: function bind(t) {
          for (var e = 0; e < t.length; e++) {
            n.on("click", t[e], this.click), n.on("touchstart", t[e], this.click, r);
          }
        },
        unbind: function unbind(t) {
          for (var e = 0; e < t.length; e++) {
            n.off(["click", "touchstart"], t[e]);
          }
        },
        click: function click(t) {
          t.preventDefault(), e.Run.make(e.Direction.resolve(t.currentTarget.getAttribute("data-glide-dir")));
        }
      };
      return d(s, "items", {
        get: function get() {
          return s._c;
        }
      }), t.on(["mount.after", "move.after"], function () {
        s.setActive();
      }), t.on("destroy", function () {
        s.removeBindings(), s.removeActive(), n.destroy();
      }), s;
    },
    Keyboard: function Keyboard(t, e, n) {
      var i = new H(),
          r = {
        mount: function mount() {
          t.settings.keyboard && this.bind();
        },
        bind: function bind() {
          i.on("keyup", document, this.press);
        },
        unbind: function unbind() {
          i.off("keyup", document);
        },
        press: function press(t) {
          39 === t.keyCode && e.Run.make(e.Direction.resolve(">")), 37 === t.keyCode && e.Run.make(e.Direction.resolve("<"));
        }
      };
      return n.on(["destroy", "update"], function () {
        r.unbind();
      }), n.on("update", function () {
        r.mount();
      }), n.on("destroy", function () {
        i.destroy();
      }), r;
    },
    Autoplay: function Autoplay(e, n, t) {
      var i = new H(),
          r = {
        mount: function mount() {
          this.start(), e.settings.hoverpause && this.bind();
        },
        start: function start() {
          var t = this;
          e.settings.autoplay && l(this._i) && (this._i = setInterval(function () {
            t.stop(), n.Run.make(">"), t.start();
          }, this.time));
        },
        stop: function stop() {
          this._i = clearInterval(this._i);
        },
        bind: function bind() {
          var t = this;
          i.on("mouseover", n.Html.root, function () {
            t.stop();
          }), i.on("mouseout", n.Html.root, function () {
            t.start();
          });
        },
        unbind: function unbind() {
          i.off(["mouseover", "mouseout"], n.Html.root);
        }
      };
      return d(r, "time", {
        get: function get() {
          var t = n.Html.slides[e.index].getAttribute("data-glide-autoplay");
          return y(t || e.settings.autoplay);
        }
      }), t.on(["destroy", "update"], function () {
        r.unbind();
      }), t.on(["run.before", "pause", "destroy", "swipe.start", "update"], function () {
        r.stop();
      }), t.on(["run.after", "play", "swipe.end"], function () {
        r.start();
      }), t.on("update", function () {
        r.mount();
      }), t.on("destroy", function () {
        i.destroy();
      }), r;
    },
    Breakpoints: function Breakpoints(t, e, n) {
      var i = new H(),
          r = t.settings,
          s = j(r.breakpoints),
          o = a({}, r),
          u = {
        match: function match(t) {
          if (void 0 !== window.matchMedia) for (var e in t) {
            if (t.hasOwnProperty(e) && window.matchMedia("(max-width: " + e + "px)").matches) return t[e];
          }
          return o;
        }
      };
      return a(r, u.match(s)), i.on("resize", window, b(function () {
        t.settings = h(r, u.match(s));
      }, t.settings.throttle)), n.on("update", function () {
        s = j(s), o = a({}, r);
      }), n.on("destroy", function () {
        i.off("resize", window);
      }), u;
    }
  };

  function B() {
    return i(this, B), function (t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
    }(this, (B.__proto__ || Object.getPrototypeOf(B)).apply(this, arguments));
  }

  return function (t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  }(B, p), t(B, [{
    key: "mount",
    value: function value(t) {
      var e = 0 < arguments.length && void 0 !== t ? t : {};
      return function t(e, n, i) {
        null === e && (e = Function.prototype);
        var r = Object.getOwnPropertyDescriptor(e, n);

        if (void 0 === r) {
          var s = Object.getPrototypeOf(e);
          return null === s ? void 0 : t(s, n, i);
        }

        if ("value" in r) return r.value;
        var o = r.get;
        return void 0 !== o ? o.call(i) : void 0;
      }(B.prototype.__proto__ || Object.getPrototypeOf(B.prototype), "mount", this).call(this, a({}, W, e));
    }
  }]), B;
});

},{}]},{},[2]);
